import React, { Fragment } from 'react'
import { Input, Radio, Checkbox, Form, Space,Select } from "antd";
import debounce from 'lodash/debounce'

const { TextArea } = Input;
 
export const FormItemContent = ({ values,type = 'input', onChange, value: formValue = '',  ...rest }: any) => {
    const [value, setValue] = React.useState()

    const handleChange = (v: any) => {
        setValue(v)
        debounceChange(v) 
    }
    const debounceChange = React.useMemo(() => debounce(onChange, 400), [])
    
    React.useEffect(() => {
        setValue(formValue?.toString()) // 新增加的两个字段 在原有的数据里为 null 默认赋值没有起效。在toString 增加兼容
    }, [formValue])

    const fixProps = {
        ...rest,
        value,
        // defaultValue: rest.initialValue,
        onChange: function(e: any) {
            // 兼容不同组件的传值
            if(e?.target) {
                handleChange(e.target.value)
            } else {
                handleChange(e)
            }
        }
    }
 
    const valueContent: {[s: string]: any} = {
        'input': <Input {...fixProps} />,
        'hidden': <Input type="hidden" {...fixProps} />,
        'textarea': <TextArea autoSize={{ minRows: 2, maxRows: 8 }} {...fixProps} />,
        'radio': <Radio.Group {...fixProps} >
            {
                values?.map((value: any) => (
                    <Radio key={value.key} value={value.key}>{value.title}</Radio>
                ))
            }
        </Radio.Group>,
        'checkbox': <Checkbox.Group {...fixProps} >
            <Space wrap>
            {
                values?.map((value: any) => (
                    <Checkbox key={value.key} value={value.key}>{value.title}</Checkbox>
                ))
            }
            </Space>
        </Checkbox.Group>,
         'select':  <Select {...fixProps} >
                        
                    </Select>
    } 
    return <Fragment>{valueContent[type]}</Fragment>
}

const Wrap = ({children, setState, defaultValue, ...props}: any) => {
    React.useEffect(() => {
        if(defaultValue !== props.value) {
            setState('success')
        } else {
            setState('')
        }
    }, [defaultValue, props.value])
    
    return <React.Fragment>
        {React.cloneElement(children, props)}
    </React.Fragment>
}

export const FormItem = ({children, defaultValue, ...props}: any) => {
    const [state, setState] = React.useState('')
    const iProps: any = {}
    if(state !== '' && defaultValue !== undefined) {
        // iProps.validateStatus = state
        // iProps.hasFeedback = true
    }

    return <Form.Item {...props} {...iProps}>
        <Wrap setState={setState} defaultValue={defaultValue}>
            {children}
        </Wrap>
    </Form.Item>
}